<template>
  <b-row class="dashboard-indicadores-historico-ventas-clientes">
    <b-col cols="12">
      <label class="titulo" v-if="showTitulo">{{ titulo }}</label>
      <b-table hover
          responsive="sm" 
          class="registro"
          :busy="tableBusy"
          :items="indicadoresVentasClientes" 
          :fields="indicadoresVentasClientesFields">
        <div slot="table-busy" class="text-center">
          <b-spinner class="table-spinner" label="Spinning" />
        </div>
        <template v-slot:cell(pjeObjetivo)="data">
          {{ data.item.pjeObjetivo | porcentaje }}
        </template>
        <template v-slot:cell(pjeActual)="data">
          {{ (parseFloat(100) - data.item.pjeActual) | porcentaje }}
        </template>

        <template v-slot:cell(detailShowing)="row">
          <b-btn class="detailShowing" 
              size="sm" 
              @click.stop="row.toggleDetails">
            {{ ( row.detailsShowing) ? '-' : '+' }}
          </b-btn>            
        </template>

        <template v-slot:row-details="row">
          <b-row>
            <b-col cols="12">
              <p>Información del Indicador:</p>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="2">
              <p class="descripcion">Monto PG</p>
            </b-col>
            <b-col cols="2">
              <p class="descripcion">{{ row.item.montoBasePG | moneda }}</p>
            </b-col>
            <b-col cols="8">
              <p class="descripcion">{{ porcentajePG(row.item) | porcentaje }}</p>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="2">
              <p class="descripcion">Monto Genomma</p>
            </b-col>
            <b-col cols="2">
              <p class="descripcion">{{ row.item.montoBaseGnm | moneda }}</p>
            </b-col>
            <b-col cols="8">
              <p class="descripcion">{{ porcentajeGnm(row.item) | porcentaje }}</p>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="2">
              <p class="descripcion">Monto Otros</p>
            </b-col>
            <b-col cols="2">
              <p class="descripcion">{{ row.item.montoBaseOtros | moneda }}</p>
            </b-col>
            <b-col cols="8">
              <p class="descripcion">{{ porcentajeOtros(row.item) | porcentaje }}</p>
            </b-col>
          </b-row>
        </template>
      </b-table>
    </b-col>
  </b-row>
</template>

<script>

export default {
  props: {
    semestral: {
      type: Boolean,
      default: true
    },
    totalNegocio: {
      type: Boolean,
      default: false
    },
    showTitulo: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      indicadoresVentasClientes: [],
      indicadoresVentasClientesFields: [
        {
            key: 'detailShowing',
            label: '',
            class: 'text-center'
        },
        { 
          key: 'indicadorPeriodo',
          label: 'Periodo' 
        },
        { 
          key: 'pjeObjetivo',
          class: 'text-right'
        },
        { 
          key: 'pjeActual',
          label: 'Pje Real',
          class: 'text-right'
        },
        { 
          key: 'descripcion',
          label: 'Descripción'
        },
      ],

      tableBusy: false
    }
  },
  computed: {
    titulo() {
      if ((/true/i).test(this.totalNegocio)) {
        return `Mix de Clientes - ${this.semestral? 'Semestral' : 'Anual'}`;
        // return `Mix de Clientes - Total Negocio - ${this.semestral? 'Semestral' : 'Anual'}`;
      }

      return `Mix de Clientes - Sin Reembolsos - ${this.semestral? 'Semestral' : 'Anual'}`;
      // return `Mix de Clientes - ${this.semestral? 'Semestral' : 'Anual'}`;
    }
  },
  methods: {
    getIndicadores() {
      let dispatch = 'resultadosVentas/getIndicadoresVentasMixClientesHistorico';
      let getter = 'resultadosVentas/indicadoresVentasMixClientesHistorico';

      if ( (/true/i).test(this.totalNegocio)) {
        dispatch = 'resultadosVentas/getIndicadoresVentasTotalMixClientesHistorico';
        getter = 'resultadosVentas/indicadoresVentasTotalMixClientesHistorico';
      }

      if (!(/true/i).test(this.semestral)) {
        if ( (/true/i).test(this.totalNegocio)) {
          dispatch = 'resultadosVentas/getIndicadoresVentasTotalMixClientesAnualHistorico';
          getter = 'resultadosVentas/indicadoresVentasTotalMixClientesAnualHistorico';
        } else {
          dispatch = 'resultadosVentas/getIndicadoresVentasTotalMixClientesAnualHistorico';
          getter = 'resultadosVentas/indicadoresVentasTotalMixClientesAnualHistorico';
        }
      }

      this.tableBusy = true;
      this.$store.dispatch(dispatch)
        .then(() => {
          this.indicadoresVentasClientes = this.$store.getters[getter];
          this.tableBusy = false;
        });
    },
    porcentajePG(indicador) {
      let montoVentas = parseFloat(indicador.montoBasePG) 
        + parseFloat(indicador.montoBaseGnm) 
        + parseFloat(indicador.montoBaseOtros); 
      
      return parseFloat(indicador.montoBasePG) / montoVentas * parseFloat(100)
    },
    porcentajeGnm(indicador) {
      let montoVentas = parseFloat(indicador.montoBasePG) 
        + parseFloat(indicador.montoBaseGnm) 
        + parseFloat(indicador.montoBaseOtros); 
      
      return parseFloat(indicador.montoBaseGnm) / montoVentas * parseFloat(100)
    },
    porcentajeOtros(indicador) {
      return parseFloat(100) - parseFloat(indicador.pjeActual);
    },
  }
}
</script>

<style>
  .dashboard-indicadores-historico-ventas-clientes .registro table td[aria-colindex="1"] {
    width: 30px !important;
  }
  .dashboard-indicadores-historico-ventas-clientes .registro table td[aria-colindex="2"] {
    width: 30% !important;
  }
  .dashboard-indicadores-historico-ventas-clientes .registro table td[aria-colindex="3"],
  .dashboard-indicadores-historico-ventas-clientes .registro table td[aria-colindex="4"] {
    width: 15% !important;
  }
  .dashboard-indicadores-historico-ventas-clientes .registro table td[aria-colindex="5"] {
    width: calc(40% - 30px) !important;
  }

  .dashboard-indicadores-historico-ventas-clientes .registro table tr.b-table-details td {
    padding-left: 30px;
    padding-bottom: 30px;
  }
  .dashboard-indicadores-historico-ventas-clientes .registro table tr.b-table-details td .row {
    margin-bottom: 0px !important;
  }
  .dashboard-indicadores-historico-ventas-clientes .registro table tr.b-table-details td .row p {
    margin-bottom: 5px !important;
  }
</style>